<template>
  <div>
    <m-card outlined class="ap-mdc-card--list-item-inmueble">
      <m-card-primary-action :ripple="false">
        <div @click="onCardClick()">
          <div>
            <div class="item-inmueble-container">
              <div class="item-inmueble-container__content">
                <div class="item-inmueble-container">
                  <div class="item-inmueble__tipo-bien">
                    {{ apItem.tipoBien }}
                  </div>
                  <div class="item-inmueble__referencia">
                    {{ apItem.referencia }}
                  </div>
                </div>
                <div class="item-inmueble__promocion">
                  {{ nombrePromocionLimited }}
                </div>
                <div
                  class="item-inmueble-container"
                  style="align-items: center;"
                >
                  <div
                    v-bind:class="{
                      'item-inmueble__detalle': true,
                      'mda-hide-on-not-desktop': apItem.videos.es
                    }"
                  >
                    {{ apItem.provincia }} - {{ apItem.superficie }}
                  </div>
                  <div class="item-inmueble__estado">
                    <m-chip-set>
                      <m-chip v-if="apItem.fichaUrl" class="mdc-chip--ficha">
                        <m-icon icon="library_books" slot="leadingIcon" />
                      </m-chip>
                      <m-chip>
                        <m-icon
                          :icon="iconForOferta(apItem.oferta)"
                          slot="leadingIcon"
                        />
                        {{ formatOferta2Label(apItem.oferta) }}
                      </m-chip>
                    </m-chip-set>
                  </div>
                </div>
              </div>
              <div
                v-if="apItem.videos.es"
                :style="style4VideoPreview(apItem.videos.es)"
              >
                <div style="position: absolute; bottom: 0">
                  <m-chip-set>
                    <m-chip
                      style="height: 30px; font-size: 0.8em; color: rgba(0, 0, 0, 0.6)"
                    >
                      <m-icon icon="video_library" slot="leadingIcon" />
                      <!-- <span>con vídeo</span> -->
                    </m-chip>
                  </m-chip-set>
                </div>
              </div>
            </div>
          </div>
        </div>
      </m-card-primary-action>
    </m-card>
  </div>
</template>

<script>
export default {
  name: "app-inmuebles-list-item",
  props: {
    apItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isDialogOpen: false
    };
  },
  computed: {
    nombrePromocionLimited() {
      let result = this.apItem.nombrePromocion;

      if (result && result.length > 30) {
        result = result.substr(0, 30) + " ...";
      }

      return result;
    }
  },
  methods: {
    formatOferta2Label(oferta) {
      return oferta && oferta === "S" ? "en venta" : "consultar";
    },
    iconForOferta(oferta) {
      switch (oferta) {
        case "S":
          return "thumb_up";
        default:
          return "contact_support";
      }
    },
    onCardClick() {
      // this.isDialogOpen = true;
      var eventData = this.$mdApp.utils.cloneObject(this.apItem);
      this.$emit("listItemClicked", eventData);
    },
    filterTerms4inmueble() {
      return {
        TIPO_OFERTA: this.apItem.tipoOferta,
        PROVINCIA: this.apItem.provincia,
        TIPO_BIEN: this.apItem.tipoBien,
        CODPRINEXPROMO: this.apItem.codigoPromocion,
        CODPRINEXUNIDAD: this.apItem.referencia
      };
    },
    style4VideoPreview(videoId) {
      return ` -webkit-order: 0; -ms-flex-order: 0; order: 0; -webkit-flex: 0 1 120px; -ms-flex: 0 1 120px; flex: 0 1 120px; -webkit-align-self: auto; -ms-flex-item-align: auto;   align-self: auto; background-image: url("https://i.ytimg.com/vi/${videoId}/mqdefault.jpg");`;
    }
  }
};
</script>

<style lang="scss">
.mdc_card.ap-mdc-card--list-item-inmueble {
  padding: 24px;
}

.item-inmueble__tipo-bien {
  // display: inline-block;
  font-size: 13px;
  font-weight: 500;
  color: #455a64;
  padding: 8px;
}

.item-inmueble__referencia {
  // display: inline-block;
  // position: absolute;
  // right: 3px; // Para situarla a la esquina
  font-size: 15px;
  font-weight: 500;
  color: #263238;
  padding: 8px;
}

.item-inmueble__promocion {
  font-size: 16px;
  font-weight: bold;
  color: #263238;
  padding: 8px;
}

.item-inmueble__detalle {
  font-size: 14px;
  color: #263238;
  padding: 8px 0 8px 8px;
}

.item-inmueble__estado {
  // display: inline-block;
  // position: absolute;
  // bottom: 0px;
  // right: 3px;

  .mdc-chip__icon--leading {
    color: rgba(0, 0, 0, 0.6);
  }
  .mdc-chip {
    height: 30px;
    padding-right: 8px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.6);
  }
  .mdc-chip--ficha {
    padding-right: 4px;
  }

  .mdc-chip:hover {
    color: rgba(0, 0, 0, 0.6);
  }
}

.app-inmueble-list-item__dialog {
  .mdc-dialog__surface {
    max-width: 900px !important;
  }
}

.item-inmueble-container {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: space-between;
  -webkit-align-content: stretch;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: stretch;
}

.item-inmueble-container__content {
  -webkit-order: 0;
  -ms-flex-order: 0;
  order: 0;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -webkit-align-self: auto;
  -ms-flex-item-align: auto;
  align-self: auto;
}

.item-inmueble-container__video-preview {
  -webkit-order: 0;
  -ms-flex-order: 0;
  order: 0;
  -webkit-flex: 0 1 120px;
  -ms-flex: 0 1 120px;
  flex: 0 1 120px;
  -webkit-align-self: auto;
  -ms-flex-item-align: auto;
  align-self: auto;
  background-image: url("https://i.ytimg.com/vi/wnroXMq22sg/mqdefault.jpg");
}
</style>
